import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useContactUsForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Check Info',
        isTitleHidden: true,
        fields: [
          {
            title: 'Email',
            name: '_contact.email',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Phone',
            name: '_contact.phone',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Address',
            name: '_contact.address',
            type: 'textarea',
            readOnly: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useContactUsForm;
